import type { DeleteInternalAuditsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (trpcData: {
  affected_rows: number;
}): DeleteInternalAuditsMutation => {
  return {
    delete_internal_audit_entity: {
      __typename: 'internal_audit_entity_mutation_response',
      affected_rows: trpcData.affected_rows,
    },
  };
};

export const useDeleteInternalAuditsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.internalAuditEntity.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.internalAuditEntity.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey:
            trpc.frontend.internalAuditEntity.internalAuditById.queryKey(),
        });
      },
    }),
  });

  return {
    deleteInternalAudits: async (
      ids: string[]
    ): Promise<DeleteInternalAuditsMutation> => {
      const result = await mutation.mutateAsync({ Ids: ids });

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
